import * as TYPES from './types';
export default {
    [TYPES.SET_MEDIAN](payload = '') {
        this.median = payload;
    },
    [TYPES.SET_EST_PRICE_VALUE](payload = 0) {
        this.estPriceValue = payload;
    },
    [TYPES.SET_RENTAL](payload) {
        this.rental = payload;
    },
    async [TYPES.FETCH_SNAPSHOT_LISTINGS]({ params, isCms = false }) {
        if (isCms) {
            let res = await import(
                /* webpackChunkName: "facts_estimate_mock"*/ '../cms-data-mock'
            );
            let result = res.default;
            this[TYPES.SET_MEDIAN](
                result.statsResults.statResultList[0].median
            );
        } else {
            let res = await this.axiosIns.get(`/api-site/snapshot/listings`, {
                params
            });
            const result =
                (res.statsResults &&
                    res.statsResults.statResultList &&
                    res.statsResults.statResultList[0]) ||
                {};
            //  Take the average value of sales
            this[TYPES.SET_MEDIAN](result.median);
        }
    },
    async [TYPES.FETCH_EVALUATION_ADDRESS](address) {
        let { data } = await this.axiosIns.get(
            `/api-site/evaluation/address?address=${address}`
        );
        if (data && data.zestimate) {
            this[TYPES.SET_EST_PRICE_VALUE](Number(data.zestimate.amount));
        }
        if (data && data.rental) {
            this[TYPES.SET_RENTAL](data.rental.amount);
        }
    }
};
